import React, { useState, useEffect } from 'react';
import { API_URL } from '../../config';
import { authFetch } from '../../utils';

const HOURS = 24;

const thStyle = { padding: '8px 12px', textAlign: 'left', borderBottom: '2px solid #dee2e6', fontSize: '13px', color: '#495057' };
const tdStyle = { padding: '8px 12px', borderBottom: '1px solid #f0f0f0', fontSize: '13px' };
const tableStyle = { width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff', borderRadius: '6px', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' };

export default function VocShipmentsTab() {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDetectors, setSelectedDetectors] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    authFetch(`${API_URL}smoke-detectors/voc-summary?hours=${HOURS}`)
      .then(res => res.ok ? res.json() : [])
      .then(data => {
        const list = Array.isArray(data) ? data : [];
        setStats(list);
        setSelectedDetectors(list.map(s => s.detectorId));
      })
      .catch(() => setStats([]))
      .finally(() => setLoading(false));
  }, []);

  const allDetectorIds = stats.map(s => s.detectorId);
  const allSelected = selectedDetectors.length === allDetectorIds.length;

  const toggleAll = () => {
    setSelectedDetectors(allSelected ? [] : allDetectorIds);
  };

  const toggleDetector = (detectorId) => {
    setSelectedDetectors(prev =>
      prev.includes(detectorId) ? prev.filter(id => id !== detectorId) : [...prev, detectorId]
    );
  };

  const filteredStats = stats.filter(s => selectedDetectors.includes(s.detectorId));

  if (loading) return <p style={{ color: '#6c757d' }}>Cargando...</p>;

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '1rem' }}>
      <h2 style={{ fontSize: '1.8rem', marginBottom: '1rem', textAlign: 'center' }}>
        🧪 VOCs y envíos
      </h2>
      <p style={{ fontSize: '13px', color: '#6c757d', marginBottom: '1rem' }}>
        Envíos recibidos y número de lecturas con VOC a 0 en las últimas {HOURS} horas.
      </p>

      {allDetectorIds.length > 0 && (
        <div style={{ position: 'relative', display: 'inline-block', marginBottom: '1rem' }}>
          <button
            type="button"
            onClick={() => setDropdownOpen(o => !o)}
            style={{
              padding: '0.5rem 1rem',
              border: '1px solid #ccc',
              borderRadius: '4px',
              backgroundColor: '#fff',
              cursor: 'pointer',
              fontSize: '13px'
            }}
          >
            Filtrar ({selectedDetectors.length}/{allDetectorIds.length}) ▾
          </button>

          {dropdownOpen && (
            <div style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              marginTop: '4px',
              backgroundColor: '#fff',
              border: '1px solid #ccc',
              borderRadius: '4px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              padding: '0.5rem',
              zIndex: 10,
              minWidth: '240px',
              maxHeight: '300px',
              overflowY: 'auto'
            }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '13px', padding: '0.25rem 0', cursor: 'pointer', fontWeight: 700, borderBottom: '1px solid #eee', marginBottom: '0.25rem' }}>
                <input type="checkbox" checked={allSelected} onChange={toggleAll} />
                Seleccionar todos
              </label>
              {allDetectorIds.map(detectorId => (
                <label
                  key={detectorId}
                  style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '13px', padding: '0.25rem 0', cursor: 'pointer', whiteSpace: 'nowrap' }}
                >
                  <input
                    type="checkbox"
                    checked={selectedDetectors.includes(detectorId)}
                    onChange={() => toggleDetector(detectorId)}
                  />
                  {detectorId}
                </label>
              ))}
            </div>
          )}
        </div>
      )}

      {filteredStats.length === 0 ? (
        <p style={{ color: '#6c757d' }}>Sin detectores seleccionados.</p>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle}>Detector</th>
                <th style={thStyle}>Envíos ({HOURS}h)</th>
                <th style={thStyle}>VOC a 0 ({HOURS}h)</th>
              </tr>
            </thead>
            <tbody>
              {filteredStats.map(s => (
                <tr key={s.detectorId}>
                  <td style={tdStyle}>{s.detectorId}</td>
                  <td style={{ ...tdStyle, color: s.submissions === 0 ? '#dc2626' : 'inherit', fontWeight: s.submissions === 0 ? 600 : 'normal' }}>
                    {s.submissions}
                  </td>
                  <td style={{ ...tdStyle, color: s.vocZeroCount > 0 ? '#d97706' : 'inherit', fontWeight: s.vocZeroCount > 0 ? 600 : 'normal' }}>
                    {s.vocZeroCount}{s.submissions > 0 ? ` (${Math.round(s.vocZeroCount / s.submissions * 100)}%)` : ''}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
